import { BirthdatePicker } from '@/shared/ui/components'
import { MinorWarningNotice } from './minor-warning-notice'
import type { JoinFormValues } from './form-values'

export type DateOfBirthSectionProps = {
  values: JoinFormValues
  errors: Record<string, string>
  isSubmitting: boolean
  isMinor: boolean
  age?: number
  onFieldChange: (field: keyof JoinFormValues, value: string) => void
}

export function DateOfBirthSection({
  values,
  errors,
  isSubmitting,
  isMinor,
  age,
  onFieldChange,
}: DateOfBirthSectionProps) {
  return (
    <div className="flex flex-col gap-4">
      <BirthdatePicker
        id="dateOfBirth"
        label="Date of birth"
        required
        value={values.dateOfBirth ?? ''}
        onChange={(v) => onFieldChange('dateOfBirth', v)}
        error={errors.dateOfBirth}
        disabled={isSubmitting}
      />
      {isMinor ? <MinorWarningNotice age={age} /> : null}
    </div>
  )
}
